import { toLocal } from '$gbusiness/helpers/date';

export default interface FileModel {
  id: number;
  name: string;
  description: string;
  moduleId?: number;
  isMain?: boolean;
  isManual?: boolean;
  isProtected?: boolean;
  passcode?: string;
  fileName: string;
  fileType: string;
  fileSize?: number;
  fileUrl: string;
  isImage?: boolean;
  storeIds?: Array<number>;
  sizes?: {
    original: string;
    medium: string;
    small: string;
  };
  youtubeLink?: string;
  createdAt?: string;
}

export const deriveRawToFile = (raw) => {
  return {
    id: raw.id,
    isMain: raw.isMain,
    isManual: !!raw.isManual,
    isProtected: !!raw.isProtected,
    ...(raw.moduleId && { moduleId: raw.moduleId }),
    name: raw.name,
    description: raw.description,
    fileName: raw.fileName,
    fileType: raw.fileType,
    fileSize: raw.fileSize,
    fileUrl: raw.fileUrl,
    isImage: raw.isImage,
    youtubeLink: raw.youtubeLink,
    ...(raw.storeIds && { storeIds: raw.storeIds }),
    sizes: raw.sizes,
    createdAt: toLocal(raw.createdAt),
  };
};

export const initialFile: FileModel = {
  id: 0,
  name: '',
  description: '',
  fileName: '',
  fileSize: 0,
  fileType: '',
  fileUrl: '',
  youtubeLink: '',
  isManual: false,
};
